/**
 * @file   src\components\Onboarding\Dashboard\LeftpanelTab.js
 * @brief  This file is responsible for handling general/match tabs view handling
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, createContext, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import LeftpanelTabContent from "./v2/LeftpanelTabContent";
import LeftpanelTabContentRight from "./LeftpanelTabContentRight";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../../../helpers/common";
import { useLocation, useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";

export const filterContext = createContext();
const LeftpanelTab = (props) => {
  const {
    updateFilter,
    filterQuery,
    handleGitchGenieFilter,
    clearFilterGitchaGenie,
    updateFilterGitchaGenie,
    selectedProperty,
    setSelectedProperty,
    setUserLocation,
    gitchaNotAvailble,
    userLocation,
    checkGitchaAvailableInLoc,
    mlsRestrictedCities,
  } = props;

  const [key, setKey] = useState(null);
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();

  // Initial mount + direct /match navigation only
  useEffect(() => {
    let initialKey;
    if (path === "/match") {
      //To show matches want ads for link from email
      initialKey = "match";
      setLocalStorage("FilterTabKey", "match");
      removeLocalStorage("selectedPropertyId");
      removeLocalStorage("MatchSelectedClient");
    } else if (getLocalStorage("FilterTabKey")) {
      initialKey = getLocalStorage("FilterTabKey");
    } else {
      initialKey = "General";
    }
    setKey(initialKey);
    handleGitchGenieFilter(initialKey === "match");
  }, [path]);

  return (
    <>
      <Tabs
        className="mb-3"
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => {
          if (path === "/match" && k === "General") {
            navigate(pageURLs?.home);
          }
          // Batch tab switch + content switch in one handler to avoid two-render flash
          setKey(k);
          setLocalStorage("FilterTabKey", k);
          handleGitchGenieFilter(k === "match");
        }}
      >
        <Tab eventKey="General" title="Buyers">
          <LeftpanelTabContent
            updateFilter={updateFilter}
            filterQuery={filterQuery}
            setUserLocation={setUserLocation}
            userLocation={userLocation}
            gitchaNotAvailble={gitchaNotAvailble}
            checkGitchaAvailableInLoc={checkGitchaAvailableInLoc}
            mlsRestrictedCities={mlsRestrictedCities}
          />
        </Tab>
        <Tab eventKey="match" title="Match">
          <LeftpanelTabContentRight
            clearFilterGitchaGenie={clearFilterGitchaGenie}
            updateFilterGitchaGenie={updateFilterGitchaGenie}
            selectedProperty={selectedProperty}
            setSelectedProperty={setSelectedProperty}
          />
        </Tab>
      </Tabs>
    </>
  );
};
export default LeftpanelTab;
